const InventoryManagement = () => {
  return (
    <div>
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">

          <div className="px-1 flex flex-col justify-center lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem]">
            <h1 className="font-bold sm:text-3xl text-2xl text-[#373737]">
              Inventory Management
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              Inventory tracking can be time-consuming for many small and medium-sized businesses. 
              As the industry-leading logistics company, TCS distribution services are designed to effectively 
              monitor and track real-time, pre and post distribution aspects including inventory management, 
              order management, warehousing, fulfilment, shipping, purchasing, retail BI and more.
            </p>
            
          </div>
          <div className="flex-1 flex flex-col justify-center items-center">
            <img src="/distribution/Inventory-Management-Inside.jpg" alt="" className="rounded-md max-w-[100%]"/>
          </div>
        </ div>

      </div>

    </div>
  );
};
  
export default InventoryManagement;
  